<script lang="ts">
  import type {
    ClientToServerEvent as OverlayClientToServerEvents,
    ServerToClientEvents as OverlayServerToClientEvents,
  } from '@pin/schemas/overlay';
  import { distinctUntilChanged, firstValueFrom } from 'rxjs';
  import type { Socket } from 'socket.io-client';
  import { onMount } from 'svelte';
  import OverlayFeed from '../components/OverlayFeed/OverlayFeed.svelte';
  import { idToken, loginWithMicrosoft, logout, user } from '../firebase/auth';
  import { connectAdminSocket } from '../utils/adminSocket';
  import { keepScreenAwake } from '../utils/wakelock';

  let overlaySocket: Socket<
    OverlayServerToClientEvents,
    OverlayClientToServerEvents
  > | null = $state(null);

  const createSocket = () => {
    overlaySocket?.disconnect();
    overlaySocket = connectAdminSocket(
      `${import.meta.env.VITE_ADMIN_API_URL}/overlay`,
      { getIdToken: () => firstValueFrom(idToken) }
    );
  };
  onMount(keepScreenAwake);
  onMount(() => {
    const authStateSub = user
      .pipe(distinctUntilChanged((prev, curr) => prev?.uid === curr?.uid))
      .subscribe(() => {
        console.log('Creating socket due to session change');
        createSocket();
      });

    return () => {
      authStateSub.unsubscribe();
      overlaySocket?.disconnect();
    };
  });
</script>

{#if $user == null}
  <button class="login-button" onclick={loginWithMicrosoft}>
    Not logged in
  </button>
{:else}
  <button class="login-button" onclick={logout}>
    Logged in as {$user.displayName}
  </button>
{/if}
<main>
  <div class="feed-wrapper">
    <OverlayFeed {overlaySocket} presenter />
  </div>
</main>

<style>
  .login-button {
    position: absolute;
    top: 1rem;
    right: 1rem;
    font-size: 1.05rem;
    padding: 0.5rem 0.75rem;
    min-height: 2.75rem;
    min-width: 2.75rem;
    cursor: pointer;
    background: transparent;
    border: 1px solid var(--color-zinc-700);
    border-radius: 0.5rem;
    color: var(--color-zinc-200);
    transition: background 0.15s;
  }
  .login-button:hover {
    background: var(--color-zinc-800);
  }
  main {
    display: grid;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
  }
  .feed-wrapper {
    border: 1px solid rgb(83, 83, 83);
    overflow-y: auto;
  }
</style>
